import React, { useState } from "react";
import style from "./project.module.css";

const Project = ({ arr,txtarr }) => {
  const [count, setcount] = useState(0);
  
  return (
    <div className={style.proj}>
      
        <div className={style.proj1i}>
          <p
            onClick={
              count > 0
                ? () => setcount(count - 1)
                : () => setcount(arr.length - 1)
            }
            className={style.arrow}
          >
            <i className="fa-solid fa-backward"></i>
          </p>
          <img src={arr[count]} alt="" />
          <p
            onClick={
              count < arr.length - 1
                ? () => setcount(count + 1)
                : () => setcount(0)
            }
            className={style.arrow}
          >
            <i className="fa-solid fa-forward"></i>
          </p>
        
      </div>
      <div>
        <h1>{txtarr[4]}</h1>
        <div className={style.projp}>
          <i className="fa-solid fa-hand-point-right"></i>
          <p>{txtarr[0]} </p>
        </div>
        <div className={style.projp}>
          <i className="fa-solid fa-hand-point-right"></i>
          <p>{txtarr[1]}</p>
        </div>
        <div className={style.projp}>
          <i className="fa-solid fa-hand-point-right"></i>

          <p>{txtarr[2]}</p>
        </div>
        <div className={style.projp}>
          <i className="fa-solid fa-hand-point-right"></i>

          <p>{txtarr[3]}</p>
        </div>
        <div className={style.btncar}>
          <button><a href={txtarr[5]} target="_blank">Live</a></button>
          <button><i className="fa-brands fa-github"></i><a href={txtarr[6]} target="_blank">View Code</a></button>
        </div>
      </div>

    </div>
  );
};

export default Project;
